module.exports = __webpack_public_path__ + "img/logo_1496e2178.png";